/**
 * Registry blocchi dashboard "Controllo completo" — Struttura corrente.
 * `size` usa le tipologie: kpi | percentage | details | list | bar | quick-actions
 */
export const CONTROLLO_BLOCK_SIZES = [
  "kpi",
  "percentage",
  "details",
  "list",
  "bar",
  "quick-actions",
];

export const CONTROLLO_SIZE_LABELS = {
  kpi: "Piccolo (KPI)",
  percentage: "Grande con percentuale",
  details: "Grande con dettagli",
  list: "Grande con liste",
  bar: "Medio con barra",
  "quick-actions": "Azioni rapide",
};

/** Spans CSS per griglia 6 colonne (desktop). */
export function getControlloColSpanClass(size) {
  if (size === "kpi") return "lg:col-span-1";
  if (size === "percentage" || size === "details" || size === "list")
    return "lg:col-span-2";
  if (size === "bar") return "lg:col-span-2";
  if (size === "quick-actions") return "lg:col-span-6";
  return "lg:col-span-2";
}

export const CONTROLLO_CARDS_REGISTRY = [
  {
    id: "kpi-posti-totali",
    label: "Posti letto totali",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
  },
  {
    id: "kpi-ospiti-presenti",
    label: "Ospiti presenti",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
  },
  {
    id: "kpi-residenti",
    label: "Residenti in struttura",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
  },
  {
    id: "kpi-camere",
    label: "Camere e posti letto",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
  },
  {
    id: "kpi-ricavi-mese",
    label: "Ricavi mese",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
    requiresFlag: "dashboardFatturazione",
  },
  {
    id: "kpi-spese-mese",
    label: "Spese mese",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
    requiresFlag: "dashboardFatturazione",
  },
  {
    id: "kpi-margine-operativo",
    label: "Margine operativo",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
    requiresFlag: "dashboardFatturazione",
  },
  {
    id: "kpi-fatture-non-pagate",
    label: "Fatture non pagate",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
    requiresFlag: "dashboardFatturazione",
  },
  {
    id: "kpi-piani-scadenza",
    label: "Piani terap. scadenza",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
    fallbackFor: "kpi-ricavi-mese",
  },
  {
    id: "kpi-alloggiati-web",
    label: "Alloggiati Web",
    defaultSize: "kpi",
    supportedSizes: ["kpi", "percentage", "details", "list", "bar"],
    defaultVisible: true,
    fallbackFor: "kpi-fatture-non-pagate",
  },
  {
    id: "diario-consegne-oggi",
    label: "Diario consegne",
    defaultSize: "details",
    supportedSizes: ["details", "kpi", "list"],
    defaultVisible: true,
  },
  {
    id: "occupazione-camere",
    label: "Occupazione camere",
    defaultSize: "percentage",
    supportedSizes: ["percentage", "details", "kpi"],
    defaultVisible: true,
  },
  {
    id: "deblistering",
    label: "Deblistering",
    defaultSize: "bar",
    supportedSizes: ["bar", "kpi", "details"],
    defaultVisible: true,
  },
  {
    id: "attivita-recenti",
    label: "Attività recenti",
    defaultSize: "list",
    supportedSizes: ["list", "details"],
    defaultVisible: true,
  },
  {
    id: "ultimi-ospiti",
    label: "Ultimi ospiti inseriti",
    defaultSize: "list",
    supportedSizes: ["list", "details"],
    defaultVisible: true,
  },
  {
    id: "pre-ingressi",
    label: "Pre-ingressi",
    defaultSize: "list",
    supportedSizes: ["list", "details"],
    defaultVisible: true,
  },
  {
    id: "scadenze-prossime",
    label: "Scadenze prossime",
    defaultSize: "list",
    supportedSizes: ["list", "details"],
    defaultVisible: true,
  },
  {
    id: "azioni-rapide",
    label: "Azioni rapide",
    defaultSize: "quick-actions",
    supportedSizes: ["quick-actions"],
    defaultVisible: true,
  },
];

export const CONTROLLO_CARDS_BY_ID = Object.fromEntries(
  CONTROLLO_CARDS_REGISTRY.map((c) => [c.id, c])
);

export const DEFAULT_CONTROLLO_PREFS = CONTROLLO_CARDS_REGISTRY.map((c) => ({
  id: c.id,
  visible: c.defaultVisible,
  size: c.defaultSize,
}));
